import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_OCPI_PARTNER_PRICING = createActionTypes('FETCH_OCPI_PARTNER_PRICING');
export const CREATE_OCPI_PARTNER_PRICING = createActionTypes('CREATE_OCPI_PARTNER_PRICING');
export const DELETE_OCPI_PARTNER_PRICING = createActionTypes('DELETE_OCPI_PARTNER_PRICING');
export const UPDATE_OCPI_PARTNER_PRICING = createActionTypes('UPDATE_OCPI_PARTNER_PRICING');
export const GET_OCPI_PARTNER_PRICING = createActionTypes('GET_OCPI_PARTNER_PRICING');